import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordManagementScreenInvalidLinkIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 44, height: 44, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#DA291C", d: "M22 0a22 22 0 1 0 22 22A22.025 22.025 0 0 0 22 0m3.889 22 9.55-9.55a16.43 16.43 0 0 1 0 19.098zM31.55 8.56 22 18.112l-9.55-9.55a16.43 16.43 0 0 1 19.1 0M8.56 12.45 18.11 22l-9.55 9.55a16.425 16.425 0 0 1 0-19.098zm3.888 22.99L22 25.888l9.55 9.55a16.43 16.43 0 0 1-19.1 0" }));
const ForwardRef = forwardRef(SvgPasswordManagementScreenInvalidLinkIcon);
export { ForwardRef as ReactComponent };
